import { DEFAULT_OPTIONS } from './state';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').LoaderConfig} LoaderConfig
 */

/**
 * @param {State} state
 * @param {LoaderConfig} obj
 */
export function setState (state, obj) {
  state.loading = typeof obj.loading === 'undefined' ? true : !!obj.loading;
  state.opaque = !!obj.opaque;
  state.title = obj.title || '';
  state.text = obj.text || '';
  state.options = Object.assign({ ...DEFAULT_OPTIONS }, obj.options);
}
